import { connectHits, Highlight } from "react-instantsearch-dom";
import PropTypes from "prop-types";
import groupBy from "lodash/groupBy";
import RelativeLink from "app/pages/.shared/RelativeLink";
import "./SearchResults.scss";
import { FormattedMessage } from "react-intl";

const SearchResults = ({ hits, onResultClick }) => {
	const results = groupBy(hits, "categories.lvl1");

	const nodes = [];

	for (let [category, articles] of Object.entries(results)) {
		nodes.push(
			<div className="search-results__item" key={category}>
				<div className="search-results__subcategory">
					<Highlight hit={articles[0]} attribute={["categories.lvl1"]} tagName={"b"} />
				</div>
				<div className="search-results__articles">
					{articles.map(article => {
						return (
							<div key={article.objectID} className="search-results__article">
								<RelativeLink
									to={{
										pathname: `/faq/category/${
											article.categoryID
										}/subcategory/${article.subCategoryID}/article/${
											article.articleID
										}`,
									}}
									onClick={onResultClick}
								>
									<div className="search-results__title">
										<Highlight
											hit={article}
											attribute={"title"}
											tagName={"b"}
										/>
									</div>
								</RelativeLink>
							</div>
						);
					})}
				</div>
			</div>
		);
	}

	return (
		<div className="search-results">
			{nodes.length > 0 ? (
				nodes
			) : (
				<div className="search-results__no-results">
					<FormattedMessage id="faq.search.no.result" />
				</div>
			)}
		</div>
	);
};

SearchResults.propTypes = {
	hits: PropTypes.array,
	onResultClick: PropTypes.func,
};

SearchResults.defaultProps = {
	hits: [],
	onResultClick: () => {},
};

export default connectHits(SearchResults);
